import React, { useEffect, useState } from 'react';
import DropDown from '../DropDown';
import { Box, InputLabel, Snackbar, useMediaQuery } from '@mui/material';
import { useQueryParameters } from '../useQueryParameters';
import { useDispatch, useSelector } from 'react-redux';
import { setInputValues, setSingedFields } from '../../../Store/Redux/FileListSlice';
import { getPdfSingFeild, getSignFields } from './Fields/GetFields';
import { nanoid } from 'nanoid';
import { getSignCords } from '../../../Services/APIConfig';
import CustomToast from '../CustomToast';

function CKeditorSignDropDown({
  recipients,
  inputFields,
  setInputFields,
  isPdf,
  templateSign,
  setTemplateSign,
  originalFile,
  setOriginalFile,
  documentID
}) {
  const { showToast } = CustomToast();
  const isMobile = useMediaQuery('(max-width:768px)');
  const { getParameter } = useQueryParameters();
  const createmode = getParameter('createmode');
  const [disabled, setDisable] = useState(false);
  const [selectedSignRecp, setSelectedSignRecp] = useState([]);
  const [showSignInput, setShowSignInput] = useState(false);
  const { pdfPage } = useSelector(state => state.ckeditor);
  const { defaultPdfSign, inputValues, selPdf } = useSelector(state => state.fileList);
  const dispatch = useDispatch();
  const [templateSignFields, settemplateSignFields] = useState([]);
  const [showmore, setShowmore] = useState(3);
  const [snackBar, setSnackbar] = useState(false);
  const [snackBarmsg, setSnackbarMsg] = useState('');

  useEffect(() => {
    if (originalFile) {

      let rfields= [];
      originalFile?.templateConfig?.fields?.map(el => {
        if( el.isrecipient === 'esign' && rfields.length <  recipients.length){
          el.uuid = recipients[rfields.length].id;
          let re= inputValues.find(r=>r.inputId==el.id && r.inval);
          if(re){
            el.selectedId=[re.inval];
          }
          rfields.push(el);
        }
      });
      settemplateSignFields(rfields)
    }
  }, [originalFile]);

  useEffect(() => {
    if (!defaultPdfSign?.enabled) {
      setSelectedSignRecp([]);
    }
    // } else {
    //   recipients.map((item, index) => {
    //     handleSignRecipient(
    //       {
    //         target: {
    //           name: item.id,
    //           value: item.id
    //         }
    //       },
    //       item.id,
    //       item.userData.firstName,
    //       index
    //     );
    //   });
    // }
  }, [defaultPdfSign]);

  useEffect(() => {
    if (inputValues.length > 0) {
      setSelectedSignRecp(inputValues);
    }
  }, [inputValues]);

  useEffect(() => {
    setTimeout(() => {
      setShowSignInput(true);
    }, 1100);
  }, []);


  const handleClearRecipientDropdown = (e, inputId, index) => {
    const { name, value } = e.target;
    let allData = { ...originalFile };
    const getRecipient = recipients.find(el => el.id === e.target.value);
    //  console.log({selectedSignRecp,name, value,inputId})  
      let  updateRecipient = selectedSignRecp?.map(el =>
        el?.name === inputId ? { ...el, value:"", inval:"", inputId:inputId} : el
      );
      getPdfSingFeild(createmode, updateRecipient);
      // updateRecipient=updateRecipient.filter(u=> u.inval);
      // console.log({updateRecipient1:updateRecipient})
      setSelectedSignRecp(updateRecipient);
      dispatch(setSingedFields(updateRecipient));
      dispatch(setInputValues(updateRecipient));
      templateSignFields.map(t=>{
        if(t.id==inputId){
          t.selectedId=[]
        }
      })
      settemplateSignFields(templateSignFields)
      allData?.templateConfig?.fields?.forEach((el) => {
        if (el.id === inputId) {
          el.value = "";
        }
      });
      setOriginalFile(allData);  
  }

  // const handleTemplateNewSignRecipient = async (e, inputId, index) => {
  //     const { name, value } = e.target;
  //     const getElement = recipients?.find(el => el.id === e.target.value);
      
  //     const Alrady = selectedSignRecp?.length > 0 && selectedSignRecp?.find(el => el?.value && el?.value === value);
  //     if(Alrady){
  //        toast.error("This Recipient Sign Already selected", {
  //         position: 'bottom-center',
  //         toastId: 'custom-tab-content-error-2'
  //       });
  //       return 
  //     }
  //     let rname=getElement?.userData?.firstName || "";
  //     let  updateRecipient=[]
  //     const checkRecipient = selectedSignRecp?.length > 0 && selectedSignRecp?.find(el => el?.uuid === getElement.uuid);
  //     if (checkRecipient) {
  //       updateRecipient = selectedSignRecp?.map(el =>
  //         el?.uuid === getElement.uuid
  //           ? { ...el, name: name,inputId,value:rname, inval: rname, uuid: getElement && getElement.uuid }
  //           : el
  //       );
  //     }else{
  //       updateRecipient = [...selectedSignRecp];
  //       updateRecipient.push({ name, value,inputId, value:rname, inval: rname, uuid: getElement && getElement.uuid });
  //     }
  //     setSelectedSignRecp(updateRecipient);
  //     dispatch(setInputValues(updateRecipient));
  //     getPdfSingFeild(createmode, updateRecipient);
  //     let allData = { ...originalFile };
  //     allData?.templateConfig?.fields?.forEach((el, index) => {
  //       if (el.id === inputId) {
  //         el.value = getElement?.userData?.firstName;
  //       }
  //     });
  //     setOriginalFile(allData);
  //     templateSignFields.map(t=>{
  //       if(t.id==inputId){
  //         t.selectedId =[getElement.userData.firstName]
  //       }
  //     })
  //     settemplateSignFields(templateSignFields)
  // }



  const handleTemplateSignRecipient = async (e, elementId, index) => {
    
    const { name, value } = e.target;
    const getElement = recipients?.find(el => el.id === e.target.value);

    if (!isPdf) {
      setDisable(true);
      
    // console.log({selectedSignRecp,name, value})  
    const Alrady = selectedSignRecp?.length > 0 && selectedSignRecp?.find(el => el?.value && el?.value === value);
   
    if(Alrady){
        setSnackbar(true);
        setSnackbarMsg('This Recipient Sign Already selected');
        setDisable(false);
      return 
    }

      const checkRecipient = selectedSignRecp?.length > 0 && selectedSignRecp?.find(el => el?.uuid === getElement.uuid);
      if (checkRecipient) {

        const updateRecipient = selectedSignRecp?.map(el =>
          el?.uuid === getElement.uuid
            ? { ...el, name: name, value, inval: getElement?.userData?.firstName, uuid: getElement && getElement.uuid }
            : el
        );
        setSelectedSignRecp(updateRecipient);
        dispatch(setInputValues(updateRecipient));
      } else {
        const newR = [...selectedSignRecp];
        newR[index] = { name, value, inval: getElement?.userData?.firstName, uuid: getElement && getElement.uuid };

        setSelectedSignRecp(newR);
        dispatch(setInputValues(newR));
      }

      const NewFieldVal = [...templateSign, { ...getElement, inputName: name, inputId: elementId, value }];

      let allData = { ...originalFile };
      allData?.templateConfig?.fields?.forEach((el, index) => {
        if (el.id === elementId) {
          el.value = getElement?.userData?.firstName;
        }
      });
      setOriginalFile(allData);
    }

    const inputId = elementId;

    templateSignFields.map(t=>{
      if(t.id==inputId){
        t.selectedId =[getElement.userData.firstName]
      }
    })
    settemplateSignFields(templateSignFields)
    
    if (createmode === 'false' && window.location.pathname !== '/templatepreview') {
      setDisable(true);
      // if (value === 'clear') {
      //   const filterInputValues = selectedSignRecp.findIndex(
      //     el => el.name === elementId && el.pdfId === selPdf.id && el.coord?.pageNo === pdfPage
      //   );
      //   const checkItemIndex = inputFields?.findIndex(el => el.inputId === inputId);
      //   if (filterInputValues < 0) {
      //     setDisable(false);
      //     toast.error('Nothing to remove', {
      //       position: 'top-center',
      //       autoClose: 500,
      //       hideProgressBar: true,
      //       toastId: 'ck-editor-sign-drop-error-1'
      //     });
      //     return;
      //   }
      //   let datatoRemove = { ...selectedSignRecp[filterInputValues] };
      //   datatoRemove.remove = true;
      //   await getSignCords(documentID, datatoRemove);
      //   const FiltertedArray = selectedSignRecp.filter((item, index) => index !== filterInputValues);
      //   const filterArr = inputFields.filter((item, index) => index !== checkItemIndex);
      //   setSelectedSignRecp(FiltertedArray);
      //   dispatch(setSingedFields(filterArr));
      //   dispatch(setInputValues(FiltertedArray));

      //   toast.success('Signature removed', { position: 'top-center', autoClose: 500, hideProgressBar: true });
      //   return setDisable(false);
      // }

      if (selectedSignRecp.length > 0) {
        const filterEl = selectedSignRecp.find(
          el => el?.value === value && el.pdfId === selPdf.id && el.coord?.pageNo === pdfPage
        );

        if (filterEl?.coord?.pageNo === pdfPage) {
          setSnackbar(true);
          setSnackbarMsg('Signature already added to page ' + pdfPage);
          setDisable(false);
          return;
        } else {
          setSnackbar(false);
          setSnackbarMsg('');
        }
      }

      const checkRecipient =
        selectedSignRecp?.length > 0 &&
        selectedSignRecp?.find(el => el?.name === name && el?.coord?.pageNo === pdfPage && el.pdfId === selPdf.id);
      let updateRecipient = {};

      if (checkRecipient) {
        const getPage = document.querySelector('.pdf-page');
        const pageHeight = getPage?.clientHeight || 800;
        updateRecipient = selectedSignRecp?.map(el =>
          el.name === name && el?.coord?.pageNo === pdfPage && el.pdfId === selPdf.id
            ? {
                ...el,
                name: name,
                value,
                inval: getElement.userData.firstName,
                coord: { ...el.coord, newY: pageHeight, pageHeight: pageHeight * (el.coord?.pageNo || 1) }
              }
            : el
        );
      } else {
        const getPage = document.querySelector('.pdf-page');
        const getPdfHeight = getPage?.clientHeight || 700;
        const pdfWidth = getPage?.clientWidth || 550;

        const pageHeight = parseInt(getPdfHeight) || 800;
        const signId = nanoid(5);

        updateRecipient = [...selectedSignRecp];
        const findUuId = getElement.docIds.find(el => el.docId === selPdf.docId);
        let pageW = pdfWidth || 550;
        let pageH = pageHeight - 50;
        updateRecipient.push({
          name,
          value,
          uuid: findUuId?.uuid || getElement.uuid,
          inval: getElement.userData.firstName,
          pdfId: selPdf?.id,
          signId,
          pdfdataUrl: selPdf.dataUrl,
          pdfdocId: selPdf.docId,
          coord: {
            x: pdfWidth - 140,
            y: pdfPage > 1 ? pageHeight * (pdfPage - 1) - 50 : pageHeight - 50,
            newY: pageHeight - 50,
            pageNo: pdfPage,
            pageWidth: pdfWidth || 550,
            pageHeight: pageHeight * (pdfPage || 1)
          }
        });
      }
      if (!originalFile) {
        // console.log(originalFile)
        let i = updateRecipient.findIndex(
          el => el.name === name && el?.coord?.pageNo === pdfPage && el.pdfId === selPdf.id
        );
        let pdfdataUrl = updateRecipient[i]['pdfdataUrl'];
        delete updateRecipient[i]['pdfdataUrl'];
        let currentResp = await getSignCords(documentID, updateRecipient[i]);
        updateRecipient[i]['pdfdataUrl'] = pdfdataUrl;
        updateRecipient[i] = currentResp;
      }
      setSelectedSignRecp(updateRecipient);
      dispatch(setInputValues(updateRecipient));
      const newinputFields = [
        ...inputFields,
        {
          id: 'signinput' + inputId,
          inputId,
          value: getElement.userData.firstName
        }
      ];

      const checkItem = inputFields?.find(el => el.inputId === inputId);

      if (checkItem) {
        const updateFields = inputFields?.map(el =>
          el.inputId === inputId
            ? {
                ...el,
                id: 'signinput' + inputId,
                inputId,
                value: getElement.userData.firstName
              }
            : el
        );

        setInputFields(updateFields);

        dispatch(setSingedFields(updateFields));
        getPdfSingFeild(createmode, updateFields);

        setSnackbar(true);
        setSnackbarMsg('Signature updated at page' + pdfPage);

        setTimeout(() => {
          setDisable(false);
          setSnackbar(false);
          setSnackbarMsg('');
        }, 1200);
        return;
      } else {
        setInputFields(newinputFields);

        dispatch(setSingedFields(newinputFields));
        getPdfSingFeild(createmode, newinputFields);
        setSnackbar(true);
        setSnackbarMsg('Signature added to page ' + pdfPage);
        setTimeout(() => {
          setDisable(false);
          setSnackbar(false);
          setSnackbarMsg('');
        }, 1200);
        return;
      }
    }
  };

 


  const handleSignRecipient = async (e, elementId, elmname, index) => {

    const { name, value } = e.target;
    const getElement = recipients?.find(el => el.id === e.target.value);

    if (!isPdf) {
      setDisable(true);
      // console.log(e, elementId, elmname, index);

      if (value === 'clear') {
        const filterEl = selectedSignRecp?.map(el =>
          el.name === elementId ? { ...el, name: name, value: elmname } : el
        );
        const filterInput = templateSign?.map(el =>
          el.inputName === elementId ? { ...el, userData: { firstName: elmname } } : el
        );

        setTemplateSign(filterInput);
        setSelectedSignRecp(filterEl);
        dispatch(setSingedFields(filterInput));
        return getSignFields(createmode, templateSign);
      }

      const checkRecipient = selectedSignRecp?.length > 0 && selectedSignRecp?.find(el => el?.name === name);

      if (checkRecipient) {
        const updateRecipient = selectedSignRecp?.map(el =>
          el.name === name
            ? { ...el, name: name, value, inval: getElement?.userData?.firstName, uuid: getElement && getElement.uuid }
            : el
        );
        setSelectedSignRecp(updateRecipient);
        dispatch(setInputValues(updateRecipient));
      } else {
        const newR = [...selectedSignRecp];
        newR[index] = { name, value, inval: getElement?.userData?.firstName, uuid: getElement && getElement.uuid };

        setSelectedSignRecp(newR);
        dispatch(setInputValues(newR));
      }

      const NewFieldVal = [...templateSign, { ...getElement, inputName: name, inputId: elementId, value }];

      let allData = { ...originalFile };
      allData?.templateConfig?.fields?.forEach((el, index) => {
        if (el.id === elementId) {
          el.value = getElement?.userData?.firstName;
        }
      });
      setOriginalFile(allData);
    }

    const inputId = elementId;

    if (createmode === 'false' && window.location.pathname !== '/templatepreview') {
      setDisable(true);
      if (value === 'clear') {
        const filterInputValues = selectedSignRecp.findIndex(
          el => el.name === elementId && el.pdfId === selPdf.id && el.coord?.pageNo === pdfPage
        );
        const checkItemIndex = inputFields?.findIndex(el => el.inputId === inputId);
        if (filterInputValues < 0) {
          setDisable(false);
          showToast('error', 'Nothing to remove');
          return;
        }

        let datatoRemove = { ...selectedSignRecp[filterInputValues] };
        datatoRemove.remove = true;
        await getSignCords(documentID, datatoRemove);
        const FiltertedArray = selectedSignRecp.filter((item, index) => index !== filterInputValues);
        const filterArr = inputFields.filter((item, index) => index !== checkItemIndex);
        setSelectedSignRecp(FiltertedArray);
        dispatch(setSingedFields(filterArr));
        dispatch(setInputValues(FiltertedArray));
        showToast('success', 'Signature removed');

        return setDisable(false);
      }
      if (selectedSignRecp.length > 0) {
        const filterEl = selectedSignRecp.find(
          el => el?.value === value && el.pdfId === selPdf.id && el.coord?.pageNo === pdfPage
        );

        if (filterEl?.coord?.pageNo === pdfPage) {
          setSnackbar(true);
          setSnackbarMsg('Signature already added to page ' + pdfPage);
          setDisable(false);
          return;
        } else {
          setSnackbar(false);
          setSnackbarMsg('');
        }
      }

      const checkRecipient =
        selectedSignRecp?.length > 0 &&
        selectedSignRecp?.find(el => el?.name === name && el?.coord?.pageNo === pdfPage && el.pdfId === selPdf.id);
      let updateRecipient = {};
      if (checkRecipient) {
        const getPage = document.querySelector('.pdf-page');
        const pageHeight = getPage?.clientHeight || 800;

        updateRecipient = selectedSignRecp?.map(el =>
          el.name === name && el?.coord?.pageNo === pdfPage && el.pdfId === selPdf.id
            ? {
                ...el,
                name: name,
                value,
                inval: getElement.userData.firstName,

                coord: { ...el.coord, newY: pageHeight, pageHeight: pageHeight * (el.coord?.pageNo || 1) }
              }
            : el
        );
      } else {
        const getPage = document.querySelector('.pdf-page');
        const getPdfHeight = getPage?.clientHeight || 700;
        const pdfWidth = getPage?.clientWidth || 550;

        const pageHeight = parseInt(getPdfHeight) || 800;
        const signId = nanoid(5);

        updateRecipient = [...selectedSignRecp];
        const findUuId = getElement.docIds.find(el => el.docId === selPdf.docId);
        let pageW = pdfWidth || 550;
        let pageH = pageHeight - 50;
        updateRecipient.push({
          name,
          value,
          uuid: findUuId?.uuid || getElement.uuid,
          inval: getElement.userData.firstName,
          pdfId: selPdf?.id,
          signId,
          pdfdataUrl: selPdf.dataUrl,
          pdfdocId: selPdf.docId,
          coord: {
            x: pdfWidth - 140,
            y: pdfPage > 1 ? pageHeight * (pdfPage - 1) - 50 : pageHeight - 50,
            newY: pageHeight - 50,
            pageNo: pdfPage,
            pageWidth: pdfWidth || 550,
            pageHeight: pageHeight * (pdfPage || 1)
          }
        });
      }
      // if (!originalFile) {
      let i = updateRecipient.findIndex(
        el => el.name === name && el?.coord?.pageNo === pdfPage && el.pdfId === selPdf.id
      );
      let pdfdataUrl = updateRecipient[i]['pdfdataUrl'];
      delete updateRecipient[i]['pdfdataUrl'];
      let currentResp = await getSignCords(documentID, updateRecipient[i]);
      updateRecipient[i]['pdfdataUrl'] = pdfdataUrl;
      updateRecipient[i] = currentResp;
      // }
      setSelectedSignRecp(updateRecipient);
      dispatch(setInputValues(updateRecipient));
      const newinputFields = [
        ...inputFields,
        {
          id: 'signinput' + inputId,
          inputId,
          value: getElement.userData.firstName
        }
      ];

      const checkItem = inputFields?.find(el => el.inputId === inputId);

      if (checkItem) {
        const updateFields = inputFields?.map(el =>
          el.inputId === inputId
            ? {
                ...el,
                id: 'signinput' + inputId,
                inputId,
                value: getElement.userData.firstName
              }
            : el
        );

        setInputFields(updateFields);

        dispatch(setSingedFields(updateFields));
        getPdfSingFeild(createmode, updateFields);

        setSnackbar(true);
        setSnackbarMsg('Signature updated at page' + pdfPage);

        setTimeout(() => {
          setDisable(false);
          setSnackbar(false);
          setSnackbarMsg('');
        }, 1200);
        return;
      } else {
        setInputFields(newinputFields);

        dispatch(setSingedFields(newinputFields));
        getPdfSingFeild(createmode, newinputFields);
        setSnackbar(true);
        setSnackbarMsg('Signature added to page ' + pdfPage);
        setTimeout(() => {
          setDisable(false);
          setSnackbar(false);
          setSnackbarMsg('');
        }, 1200);
        return;
      }
    }
  };

  const handleShowmore = () => {
    if (showmore > 10) {
      return;
    }
    setShowmore(preValue => preValue + 10);
  };
  const handleShowLess = () => {
    if (showmore < 3) {
      return;
    }
    setShowmore(3);
  };
  // console.log({selectedSignRecp,templateSignFields});
  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: isMobile ? 'bottom' : 'top',
          horizontal: 'center'
        }}
        open={snackBar}
        autoHideDuration={6000}
        onClose={() => setSnackbar(!snackBar)}
        message={snackBarmsg}
      />
      <Box display={isPdf ? (!defaultPdfSign.enabled ? 'block' : 'none') : ''}>
        <Box mb={1}>
          <div className='medium5'>Add Signature</div>
        </Box>
        <Box display={'flex'} flexDirection={'column'} py={isMobile ? 1 : 2} rowGap={1}>
          {
          
          !isPdf &&
            templateSignFields
              ?.slice(0, showmore)
              ?.map((item, index) => (
                <DropDown
                  key={item.id}
                  // disabled={disabled}
                  width={isMobile ? '95%' : '100%'}
                  height={isMobile ? '40px' : '45px'}
                  placeholder={item.fieldname}
                  name={item.id}
                  showClear={true}
                  handleChange={e => handleTemplateSignRecipient(e, item.id, item.fieldname)}
                  dropdownValue={recipients.map(el => ({ ...el.userData, id: el.id, name: el.userData.firstName }))}
                  dropDownSelected={[item.selectedId || '']}
                  handleClearSelection={e => handleClearRecipientDropdown(e, item.id)}
                />
              ))}

          {isPdf &&
            showSignInput &&
            recipients.map((item, index) => (
              <React.Fragment key={index}>
                <InputLabel id='select-label' className='medium5'>
                  {'Recipient ' + (index + 1)}
                </InputLabel>
                <DropDown
                  key={item.id}
                  disabled={disabled}
                  width={isMobile ? '95%' : '100%'}
                  height={isMobile ? '40px' : '45px'}
                  placeholder={'Recipient ' + (index + 1)}
                  name={item.id}
                  showClear
                  handleChange={e => handleSignRecipient(e, item.id, item.userData.firstName, index)}
                  handleClearSelection={e =>
                    handleSignRecipient({ ...e, target: { value: 'clear' } }, item.id, item.userData.firstName, index)
                  }
                  dropdownValue={recipients.map(el => ({ ...el.userData, id: el.id, name: el.userData.firstName }))}
                  dropDownSelected={selectedSignRecp.map(el => {
                    if (el.name === item.id && el?.coord?.pageNo === pdfPage && el.pdfId === selPdf.id) {
                      return el.inval;
                    } else {
                      return '';
                    }
                  })}
                />
              </React.Fragment>
            ))}
        </Box>
        <Box mt={1} display={isPdf ? 'none' : 'flex'} columnGap={1}>
          {templateSignFields?.length > 3 && showmore === 3 ? (
            <div className='medium5 pointer-css green-color' onClick={handleShowmore}>
              Show more{' '}
            </div>
          ) : (
            ''
          )}
          {showmore > 3 && (
            <div className='medium5 pointer-css green-color' onClick={handleShowLess}>
              Show less{' '}
            </div>
          )}
        </Box>
      </Box>
    </>
  );
}

export default CKeditorSignDropDown;
